var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOlmIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "#0f1689",
    stroke: "null",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50 13.336A36.664 36.664 0 1 0 86.664 50 36.673 36.673 0 0 0 50 13.336zm21.42 33.507L46.989 79.185c-.388.526-.776 1.311-1.484.923s-.259-1.182 0-1.838l5.633-20.584c.492-1.613 0-1.967-1.475-1.924H31.435l-2.976-.155 29.806-37.958c.664 1.311 0 2.053-.259 2.838l-8.213 22.292c-.699 1.872-.397 2.312 1.57 2.312h19.186c.518 0 1.216-.259 1.527.311s-.354 1.001-.656 1.441z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlmIconWhite);
export default __webpack_public_path__ + "static/media/olm-icon-white.b29888b4fca3938a823b951065cbe003.svg";
export { ForwardRef as ReactComponent };